import { NotificationService, useIntl } from '@capsicum/common';
import { Snackbar } from '@capsicum/common-web';
import { useRef } from 'react';

export const useNetworkFeeErrorSnackbar = () => {
	const { $t } = useIntl();
	const hasSnackbarShown = useRef(false);

	const showNetworkFeeErrorSnackbar = () => {
		if (hasSnackbarShown.current) return;

		hasSnackbarShown.current = true;
		NotificationService.addNotification({
			component: (
				<Snackbar
					description={$t('staking.snackbar.networkFeeError.description')}
					testID="stakeFanTokens-review-errorSnackbar"
					title={$t('staking.snackbar.networkFeeError.title')}
					variant="error"
				/>
			)
		});
	};

	return {
		showNetworkFeeErrorSnackbar
	};
};
